import { render, staticRenderFns } from "./form-email-update.vue?vue&type=template&id=49bde6b4&"
import script from "./form-email-update.vue?vue&type=script&lang=js&"
export * from "./form-email-update.vue?vue&type=script&lang=js&"
import style0 from "./form-email-update.vue?vue&type=style&index=0&id=49bde6b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports